import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ jc }) => jc || 'flex-start'};
  width: 100%;
  min-width: 180px;
  ${({ theme }) => theme.media.tablet} {
    justify-content: ${({ jcT }) => jcT || 'flex-start'};
  }
  ${({ theme }) => theme.media.mobile} {
    justify-content: ${({ jcM }) => jcM || 'flex-start'};
  }
`;

export const ShareWrapper = styled.div`
  margin-right: 0.2rem;
`;
